import { render, staticRenderFns } from "./DailyRewardListener.vue?vue&type=template&id=e70124c2&scoped=true"
import script from "./DailyRewardListener.vue?vue&type=script&lang=js"
export * from "./DailyRewardListener.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70124c2",
  null
  
)

export default component.exports